import { OverrideScope } from '@/api/Wallet/Types/WithdrawalAutomationDto'
import { FormSelectOption } from '@/components/Form/FormField'

export const EMPTY_SCOPE: OverrideScope = {
  tickmillCompanyId: null,
  countryId: null,
  paymentProviderId: null,
  clientTypeId: null,
  walletTypeId: null,
}

export const parseScopeNumber = (value: string | number | null | undefined): number | null =>
  value === null || value === undefined || value === '' ? null : Number(value)

export const parseScopeString = (value: string | number | null | undefined): string | null =>
  value === null || value === undefined || value === '' ? null : String(value)

export const toScopePayload = (scope: OverrideScope): OverrideScope => ({
  tickmillCompanyId: scope.tickmillCompanyId,
  countryId: scope.countryId,
  paymentProviderId: scope.paymentProviderId,
  clientTypeId: scope.clientTypeId,
  walletTypeId: scope.walletTypeId,
})

export const hasAtLeastOneScope = (scope: OverrideScope): boolean =>
  scope.tickmillCompanyId !== null ||
  scope.countryId !== null ||
  scope.paymentProviderId !== null ||
  scope.clientTypeId !== null ||
  scope.walletTypeId !== null

export const scopeLabel = (value: string | number | null, options: FormSelectOption[]): string => {
  if (value === null || value === undefined) return 'All'
  const found = options.find((option) => String(option.id) === String(value))
  return found?.name ?? String(value)
}
